import React, { useState, useMemo } from 'react';
import { ChevronDownIcon, MagnifyingGlassIcon, QuestionMarkCircleIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openItems, setOpenItems] = useState<number[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  const toggleItem = (id: number) => {
    setOpenItems(prev => 
      prev.includes(id) 
        ? [] // Close the current item
        : [id] // Close all others and open only this one
    );
  };

  const expandAll = () => {
    setOpenItems(faqItems.map(item => item.id));
  };

  const collapseAll = () => {
    setOpenItems([]);
  };

  const faqItems: FAQItem[] = useMemo(() => [
    {
      id: 1,
      question: "Signature Styles ဆိုတာ ဘာလဲ?",
      answer: "Signature Styles သည် Nike, Adidas, Under Armour, Puma, Essential, Burberry, CK, DAKS London စသည့် နာမည်ကြီး Brand များ၏ First Copy အဝတ်အစားများ ကို ရောင်းချသော အွန်လိုင်းအဝတ်အစားဆိုင်တစ်ခုဖြစ်ပါသည်။ ကျွန်ုပ်တို့၏ ပစ္စည်းများကို Vietnam, Thailand, Cambodia, Singapore နိုင်ငံများမှ တင်သွင်းထားပြီး အရည်အသွေးမြင့်မားသော ဒီဇိုင်းများနှင့် စျေးနှုန်းသက်သာစွာဖြင့် ဝယ်ယူနိုင်ပါသည်။"
    },
    {
      id: 2,
      question: "ပစ္စည်းများကို ဘယ်လိုဝယ်ယူရမလဲ?",
      answer: "ကျွန်ုပ်တို့၏ ဝဘ်ဆိုက်တွင် အကောင့်ဖွင့်ပြီး လိုချင်သောပစ္စည်းများကို ရွေးချယ်ကာ အော်ဒါတင်နိုင်သလို Messenger, Viber, TikTok, WhatsApp တို့မှလဲ တစ်ဆင့် အော်ဒါတင် မှာယူနိုင်ပါသည်။ ငွေပေးချေမှုကို အွန်လိုင်းမှတစ်ဆင့် လုပ်ဆောင်နိုင်ပြီး ပစ္စည်းများကို သင့်အိမ်လိပ်စာအထိ ပို့ဆောင်ပေးပါမည်။"
    },
    {
      id: 3,
      question: "ပစ္စည်းများ၏ အရည်အသွေးကို ဘယ်လိုအာမခံချက်ပေးနိုင်မလဲ?",
      answer: "ကျွန်ုပ်တို့၏ ပစ္စည်းများသည် Vietnam, Thailand, Cambodia, Singapore နိုင်ငံများမှ တင်သွင်းထားသော First Copy ပစ္စည်းများ ဖြစ်ပြီး၊ မူရင်း Brand များနှင့် နီးစပ်သော အရည်အသွေးနှင့် ဒီဇိုင်းများကို ပေးစွမ်းနိုင်ပါသည်။"
    },
    {
      id: 4,
      question: "ငွေပေးချေမှုနည်းလမ်းများ ဘာတွေရှိလဲ?",
      answer: "ကျွန်ုပ်တို့၏ ဝဘ်ဆိုက်တွင် အောက်ပါငွေပေးချေမှုနည်းလမ်းများကို လက်ခံပါသည်:\n\n• Cash On Delivery\n• Banking\n• မိုဘိုင်းငွေပေးချေမှု (Wave Money, KBZ Pay, CB Pay, UAB Pay, AYA Pay, OK$)"
    },
    {
      id: 5,
      question: "ပို့ဆောင်မှုကို ဘယ်လိုလုပ်ဆောင်ပေးပါသလဲ?",
      answer: "အော်ဒါတင်ပြီးပါက ပစ္စည်းများကို သင့်အိမ်လိပ်စာအထိ 2-7 ရက်အတွင်း Royal Express, Ninja Van Express, BeeXpress တို့ဖြင့် ပို့ဆောင်ပေးပါမည်။"
    },
    {
      id: 6,
      question: "အမြန်ချောပို့ ဝန်ဆောင်မှု မရောက်တဲ့ မြို့တွေကို ဘယ်လို ပို့ဆောင်ပေးလဲ?",
      answer: "အမြန်ချောပို့ မရောက်တဲ့ မြို့တွေကို ငွေကြိုရှင်းစနစ်ဖြင့်သာ ကားဂိတ်တင်ပေးပါသည်။"
    },
    {
      id: 7,
      question: "ပစ္စည်းပြန်လဲလှယ်ခြင်း သို့မဟုတ် ပြန်အမ်းခြင်း လုပ်ဆောင်နိုင်ပါသလား?",
      answer: "ပစ္စည်းများကို လက်ခံရရှိပြီး ၂ ရက်အတွင်း ပြန်လဲလှယ်ခြင်း သို့မဟုတ် ပြန်အမ်းခြင်းကို လုပ်ဆောင်နိုင်ပါသည်။ ပစ္စည်းများသည် မပျက်စီးဘဲ မူလအတိုင်းရှိရမည်ဖြစ်ပြီး၊ ပြန်လည်ပို့ဆောင်ရန် လိုအပ်ပါသည်။ ပစ္စည်းလဲလှယ်ခြင်းသည် ဆိုဒ်မတော်ခြင်း၊ အရောင် အဆင်မပြေခြင်းများအတွက်သာ အကျုံးဝင်ပါသည်။"
    },
    {
      id: 8,
      question: "ပစ္စည်းများ၏ စျေးနှုန်းများ ဘာကြောင့် သက်သာရသလဲ?",
      answer: "ကျွန်ုပ်တို့သည် မူရင်း Brand များ၏ First Copy ပစ္စည်းများ ကို ရောင်းချသောကြောင့်၊ မူရင်းစျေးနှုန်းများထက် သက်သာစွာဖြင့် ဝယ်ယူနိုင်ပါသည်။ သို့သော် အရည်အသွေးနှင့် ဒီဇိုင်းများကို အာမခံချက်ပေးပါသည်။"
    },
    {
      id: 9,
      question: "ဆက်သွယ်ရန်လိပ်စာနှင့် ဖုန်းနံပါတ်များ ဘယ်လိုရှိပါသလဲ?",
      answer: "ကျွန်ုပ်တို့ကို အောက်ပါလိပ်စာများမှ ဆက်သွယ်နိုင်ပါသည်:\n\n• ဖုန်းနံပါတ်: 09943000730, 09795424336\n• အီးမေးလ်: info@signaturestylesmm.com\n• လိပ်စာ: အမှတ် (၂၇)၊ ကန်တော်လမ်း၊ လေးထောင့်ကန်ရပ်ကွက်၊ သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်မြို့။\n\nအကယ်၍ သင့်တွင် အခြားမေးခွန်းများ (သို့မဟုတ်) အကြံပြုချက်များ ရှိပါက ကျွန်ုပ်တို့၏ Messenger, Viber, WhatsApp, TikTok များသို့ ဆက်သွယ်မေးမြန်းနိုင်ပါသည်။"
    }
  ], []);

  // Filter FAQ items based on search term
  const filteredFaqItems = useMemo(() => {
    if (!searchTerm.trim()) return faqItems;
    return faqItems.filter(item => 
      item.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, faqItems]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white py-12 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}></div>
        </div>
        
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="animate-fade-in-up">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white bg-opacity-10 rounded-full mb-4 backdrop-blur-sm">
              <QuestionMarkCircleIcon className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent break-words leading-relaxed">
              မေးလေ့ရှိသောမေးခွန်းများ
            </h1>
            <p className="text-base text-gray-300 mb-6 max-w-xl mx-auto leading-relaxed">
              Signature Styles အကြောင်း သိလိုသမျှ အဖြေများကို ရှာဖွေပါ
            </p>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 mx-auto rounded-full shadow-lg"></div>
          </div>
        </div>
      </div>

      {/* Search and Controls */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-2xl shadow-lg p-6 -mt-10 relative z-10 border border-gray-100">
          <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
            {/* Search Bar */}
            <div className="relative flex-1 max-w-md">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <MagnifyingGlassIcon className={`h-5 w-5 transition-colors duration-200 ${
                  isSearchFocused ? 'text-gray-500' : 'text-gray-400'
                }`} />
              </div>
              <input
                type="text"
                placeholder="မေးခွန်းများ ရှာဖွေပါ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
                className="block w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-500 transition-all duration-200 ease-in-out hover:border-gray-400 focus:outline-none focus:border-gray-500 focus:ring-4 focus:ring-gray-100 focus:shadow-md"
              />
            </div>
            
            {/* Control Buttons */}
            <div className="flex gap-2">
              <button
                onClick={expandAll}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg transition-all duration-200 ease-in-out hover:bg-gray-200 hover:shadow-sm focus:outline-none focus:ring-4 focus:ring-gray-100 active:scale-95"
              >
                အားလုံးဖွင့်ရန်
              </button>
              <button
                onClick={collapseAll}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg transition-all duration-200 ease-in-out hover:bg-gray-200 hover:shadow-sm focus:outline-none focus:ring-4 focus:ring-gray-100 active:scale-95"
              >
                အားလုံးပိတ်ရန်
              </button>
            </div>
          </div>
          
          {/* Search Results Count */}
          {searchTerm && (
            <div className="mt-4 text-sm text-gray-600">
              <span className="font-medium">{filteredFaqItems.length}</span> ခု တွေ့ရှိပါသည် "{searchTerm}" အတွက်
            </div>
          )}
        </div>
      </div>

      {/* FAQ Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        <div className="space-y-6">
          {filteredFaqItems.length === 0 ? (
            <div className="text-center py-12">
              <QuestionMarkCircleIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">မေးခွန်းများ မတွေ့ရှိပါ</h3>
              <p className="text-gray-600">အခြားစကားလုံးများဖြင့် ရှာကြည့်ပါ</p>
            </div>
          ) : (
            filteredFaqItems.map((item, index) => (
            <div
              key={item.id}
              className={`bg-white rounded-2xl shadow-sm border border-gray-200 transition-all duration-300 ease-in-out hover:shadow-lg hover:border-gray-300 transform hover:-translate-y-1 ${
                openItems.includes(item.id) ? 'ring-2 ring-gray-100 shadow-md' : ''
              } animate-fade-in`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <button
                onClick={() => toggleItem(item.id)}
                className="w-full px-8 py-6 text-left flex items-center justify-between focus:outline-none focus:ring-4 focus:ring-gray-100 rounded-2xl transition-all duration-200 ease-in-out hover:bg-gradient-to-r hover:from-gray-50 hover:to-gray-25 group"
              >
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mr-4 group-hover:from-gray-200 group-hover:to-gray-300 transition-all duration-200">
                    <span className="text-sm font-bold text-gray-600">{item.id}</span>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-800 pr-4 group-hover:text-gray-900 transition-colors duration-200">
                    {item.question}
                  </h3>
                </div>
                <div className="flex-shrink-0">
                  <div className={`p-2 rounded-full transition-all duration-200 ${
                    openItems.includes(item.id) 
                      ? 'bg-gray-100 rotate-180' 
                      : 'bg-gray-50 group-hover:bg-gray-100'
                  }`}>
                    <ChevronDownIcon className="h-4 w-4 text-gray-500 transition-all duration-200" />
                  </div>
                </div>
              </button>
              
              {openItems.includes(item.id) && (
                <div className="px-8 pb-6 animate-slide-down">
                  <div className="pt-4 border-t border-gray-100 ml-12">
                    <div className="bg-gradient-to-r from-gray-50 to-transparent p-6 rounded-xl border-l-4 border-gray-300">
                      <p className="text-gray-700 leading-relaxed whitespace-pre-line text-base">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))
          )}
        </div>

        {/* Contact Section */}
        <div className="mt-12 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl p-6 text-white text-center relative overflow-hidden shadow-xl">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M20 20c0-5.5-4.5-10-10-10s-10 4.5-10 10 4.5 10 10 10 10-4.5 10-10zm10 0c0-5.5-4.5-10-10-10s-10 4.5-10 10 4.5 10 10 10 10-4.5 10-10z'/%3E%3C/g%3E%3C/svg%3E")`
            }}></div>
          </div>
          
          <div className="relative z-10">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-white bg-opacity-10 rounded-full mb-4 backdrop-blur-sm">
              <PhoneIcon className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-xl font-bold mb-3 bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent">
              နောက်ထပ် မေးခွန်းများ ရှိပါသလား?
            </h2>
            <p className="text-gray-300 mb-6 text-sm max-w-xl mx-auto leading-relaxed">
              ကျွန်ုပ်တို့နှင့် ဆက်သွယ်ပြီး အကူအညီရယူနိုင်ပါသည်။ ၂၄ နာရီ အကူအညီပေးနိုင်ပါသည်။
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3 max-w-sm mx-auto">
              <a
                href="tel:09943000730"
                className="group bg-white text-gray-800 px-6 py-3 rounded-xl font-medium text-sm transition-all duration-300 ease-in-out hover:bg-gray-100 hover:shadow-lg focus:outline-none focus:ring-4 focus:ring-white focus:ring-opacity-50 transform hover:scale-105 flex items-center justify-center"
              >
                <PhoneIcon className="w-4 h-4 mr-2 text-green-600 group-hover:scale-110 transition-transform duration-200" />
                <span>09943000730</span>
              </a>
              <a
                href="mailto:info@signaturestylesmm.com"
                className="group bg-white text-gray-800 px-6 py-3 rounded-xl font-medium text-sm transition-all duration-300 ease-in-out hover:bg-gray-100 hover:shadow-lg focus:outline-none focus:ring-4 focus:ring-white focus:ring-opacity-50 transform hover:scale-105 flex items-center justify-center"
              >
                <EnvelopeIcon className="w-4 h-4 mr-2 text-blue-600 group-hover:scale-110 transition-transform duration-200" />
                <span>Email</span>
              </a>
            </div>
            
            {/* Additional Contact Info */}
            <div className="mt-6 pt-4 border-t border-gray-700">
              <p className="text-gray-400 text-xs">
                📍 အမှတ် (၂၇)၊ ကန်တော်လမ်း၊ လေးထောင့်ကန်ရပ်ကွက်၊ သင်္ဃန်းကျွန်းမြို့နယ်၊ ရန်ကုန်မြို့
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS for animations */}
      <style>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes slide-down {
          from {
            opacity: 0;
            transform: translateY(-10px);
            max-height: 0;
          }
          to {
            opacity: 1;
            transform: translateY(0);
            max-height: 500px;
          }
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out;
        }
        
        .animate-fade-in {
          animation: fade-in 0.5s ease-out forwards;
          opacity: 0;
        }
        
        .animate-slide-down {
          animation: slide-down 0.4s ease-out;
        }
        
        /* Smooth scroll behavior */
        html {
          scroll-behavior: smooth;
        }
        
        /* Custom scrollbar */
        ::-webkit-scrollbar {
          width: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
      `}</style>
    </div>
  );
};

export default FAQ;
